import React, { useState } from "react";
import { insertModule } from "./Services/InsertModule"
import { useEffect } from "react";
import { fetchModules, fetchModule1 } from "./Services/fetchModules";
import { updateModule } from "./Services/updateModule";
import { deleteModuleById } from "./Services/deleteModuleById";
import "./CSS/Module.css";

const CreateModules = () => {

  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/vendor/datatables/dataTables.min.js',
      'assets/vendor/datatables/dataTables.bootstrap.min.js',
      'assets/vendor/datatables/custom/custom-datatables.js',
      'assets/js/custom.js'
    ];

    let isCancelled = false;

    // Load scripts sequentially
    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
      // Optionally remove scripts if needed
    };
  }, []);


  function handleCancelMenu(e) {
    e.preventDefault();
    let divPanel = document.getElementById('divPanel')
    divPanel.style.display = "none";
    let divButtons = document.getElementById('cancel')
    divButtons.style.display = "none";

    let addButtons = document.getElementById('add')
    addButtons.style.display = "block";


  }
  const [addIcon, setAddIcon] = useState(null);
  const [editIcon, setEditIcon] = useState(null);
  const icons = [
    'ri-phone-line',
    'ri-mail-send-line',
    'ri-star-line',
    'ri-radio-2-line',
    'ri-macbook-line',
    'ri-mail-send-line',
    'ri-chat-1-line',
    'ri-emoji-sticker-line',
    'ri-stethoscope-line',
    'ri-timer-flash-line',
    'ri-wheelchair-line',
    'ri-door-line',
    'ri-building-2-line'
  ];
  const IconPickerModal = ({ modalId, onSelect }) => {


    return (
      <div className="modal fade" id={modalId} tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Icons</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">

              <div class="row gx-4">
                <div class="col-sm-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="icons-container">

                        {icons.map((iconClass) => (
                          <button
                            key={iconClass}
                            className="btn"
                            data-bs-dismiss="modal"
                            onClick={(e) => {
                              e.preventDefault();
                              onSelect(`${iconClass}`);
                              setModuleIcon(`${iconClass}`);
                            }}
                          >
                            <div className="icons" style={{ height: "50px", width: "50px", padding: "2px", fontSize: "16px" }}>
                              <i className={iconClass}></i>
                            </div>
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };


  function addMenuPanel(e) {
    e.preventDefault();
    let divPanel = document.getElementById('divPanel')
    divPanel.style.display = "block";

    let divButtons = document.getElementById('cancel')
    divButtons.style.display = "block";
    let addButtons = document.getElementById('add');
    addButtons.style.display = "none";


  }
  useEffect(() => {
    if (addIcon) {
      const timer = setTimeout(() => {
        setAddIcon(null);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [addIcon]);
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [moduleName, setModuleName] = useState("");
  const [moduleIcon, setModuleIcon] = useState("");
  const [moduleDesc, setModuleDesc] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    await insertModule({
      moduleName,
      moduleIcon,
      moduleDesc
    });

    setModuleName("");
    setModuleIcon("");
    setModuleDesc("");
    getModules();
  };
  const [modules, setModules] = useState([]);
  const [module1, setModule1] = useState('');
  const [ids, setIds] = useState(null);
  const getModules = () => {
    const fetch = async () => {
      const data = await fetchModules();
      setModules(data);
    };
    fetch();
  }
  useEffect(() => {

    getModules();
  }, []);
  useEffect(() => {
    const getModule = async () => {
      const data = await fetchModule1(ids);
      setModule1(data);
    };

    getModule();
  }, [ids]);
  const [editModuleName, setEditModuleName] = useState("");
  const [editModuleDesc, setEditModuleDesc] = useState("");
  useEffect(() => {
    const selected = module1
    if (selected) {
      setEditModuleName(selected.moduleName);
      setEditIcon(selected.moduleIcon);
      setEditModuleDesc(selected.moduleDesc);
    }
  }, [ids, module1]);

  const handleEdit = async () => {
    if (!editModuleName || !editIcon || !editModuleDesc) {
      alert("Please fill in all required fields.");
      return;
    }

    try {
      await updateModule(ids, {
        moduleName: editModuleName,
        moduleIcon: editIcon,
        moduleDesc: editModuleDesc
      });
      getModules(); // refresh table data
    } catch (err) {
      alert("Failed to update module");
    }
  };
  const [delId, setDelId] = useState(null);
  const handleDelete = async (id) => {
    await deleteModuleById(id);
    getModules();
  };

  return (
    <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#!">
              <i className="ri-home-3-line" />
            </a>
          </li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Create Modules
          </li>
        </ol>
        {/* Breadcrumb ends */}
        {/* Sales stats starts */}
        {/* <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
        <span className="input-group-text bg-primary-lighten">
          <i className="ri-calendar-2-line text-primary" />
        </span>
        <input type="text" id="abc" className="form-control custom-daterange" />
      </div>
    </div> */}
        {/* Sales stats ends */}
      </div>
      {/* App Hero header ends */}
      {/* App body starts */}
      <div className="app-body">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                {/* Custom tabs starts */}
                <div className="custom-tabs-container">
                  {/* Nav tabs starts */}

                  {/* Nav tabs ends */}
                  {/* Tab content starts */}
                  <div className="tab-content h-350" style={{ paddingTop: "0.5rem;" }}>

                    <div className="tab-pane fade show active" id="twoA" role="tabpanel">
                      {/* Row starts */}
                      <div className="row justify-content-left">
                        <div className="col-sm-12 col-12" id="divPanel" style={{ display: "none" }}>
                          <div className="card border mb-3">
                            <div className="card-body">
                              <div className="row gx-4">
                                <div className=" col-sm-5 col-12">
                                  <div className="mb-3">
                                    <label className="form-label" htmlFor="newMod">New Module <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                      <input type="text" id="newMod" className="form-control" placeholder="Create Modules."
                                        value={moduleName}
                                        onChange={(e) => setModuleName(e.target.value)} />
                                      <button className="btn btn-outline-secondary" type="button">
                                        <i className="ri-menu-line text-black" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div className=" col-sm-5 col-12">
                                  <div className="mb-3">
                                    <label className="form-label" htmlFor="newIcon">New icon <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                      <input type="text" id="newIcon" className="form-control" value={moduleIcon}
                                        placeholder="Choose Icon" disabled />
                                      <button className="btn btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#addIconPicker">
                                        <i className="ri-menu-line text-black" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div className=" col-sm-2 col-12 justify-content-end">
                                  <div className="mb-3 ">
                                    <label className="form-label" htmlFor="selectedIcon">&nbsp; </label>
                                    <div className="input-group">
                                      {/* dangerouslySetInnerHTML={{ __html: addIcon }} */}
                                      {addIcon && (<button className="btn btn-outline-secondary" id="selectedIcon"
                                      >
                                        <i className={addIcon}></i>
                                      </button>

                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row gx-4">
                                <div className=" col-sm-10 col-12">
                                  <div className="mb-3">
                                    <label className="form-label" htmlFor="newDesc">Module Description <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                      <textarea row="2" type="text" id="newDesc" className="form-control" placeholder="Modules description."
                                        value={moduleDesc}
                                        onChange={(e) => setModuleDesc(e.target.value)} />
                                      <button className="btn btn-outline-secondary" type="button">
                                        <i className="ri-menu-line text-black" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-sm-2 col-12">
                                  <div className="mb-3 justify-content-right" style={{ float: "right" }}>
                                    <label className="form-label" htmlFor="newPwd">&nbsp;</label>
                                    <div className="input-group">
                                      <button type="submit" className="btn btn-primary add-element" onClick={handleSubmit} >
                                        Add
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Row ends */}
                      <div className="card border">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="card-header">
                              <h5 className="card-title">Modules</h5>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div id="addButtons" className="d-flex justify-content-end" style={{ paddingTop: "11px", width: "100%", paddingRight: "15px" }}>
                              <button type="button" id="cancel" className="btn btn-secondary " style={{ display: "none" }} onClick={handleCancelMenu}>
                                Cancel
                              </button>
                              <button type="button" id="add" className="btn btn-primary" onClick={addMenuPanel}>
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="card-body pt-15">
                          {/* Table starts */}
                          {modules.length > 0 && (
                            <div className="table-responsive">
                              <table id="scrollVertical" className="table truncate m-0 align-middle">
                                <thead>
                                  <tr>
                                    <th>ID</th>
                                    <th>Module Name</th>
                                    <th>Module Icon</th>
                                    <th>Description</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                {/* <tbody>
        <tr>
          <td>#1</td>
          <td>
            User Module
          </td>
          <td ><span style={{padding:"5px 8px",borderRadius:"50%",backgroundColor:"rgba(193, 205, 222, 0.7)"}}><i class="ri-building-2-line"></i></span></td>
          <td>
            <div className="d-inline-flex gap-1">
              <button type="button" className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow">
                <i className="ri-delete-bin-line" />
              </button>
              <button class="btn btn-outline-success btn-sm"
                  data-bs-toggle="modal" data-bs-target="#editModules"
                  data-bs-title="Edit Modules" type="button" onClick={()=>{setIds(1)}}>
                  <i class="ri-edit-box-line"></i>
              </button>
              
            </div>
          </td>
        </tr>
        <tr>
          <td>#2</td>
          <td>
            OPD Module
          </td>
          <td><span style={{padding:"5px 8px",borderRadius:"50%",backgroundColor:"rgba(193, 205, 222, 0.7)"}}>
            <i class="ri-stethoscope-line"></i>
            </span></td>
          <td>
            <div className="d-inline-flex gap-1">
              <button type="button" className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow">
                <i className="ri-delete-bin-line" />
              </button>
              <button class="btn btn-outline-success btn-sm"
                  data-bs-toggle="modal" data-bs-target="#editModules"
                  data-bs-title="Edit Modules" type="button" onClick={()=>{setIds(2)}}>
                  <i class="ri-edit-box-line"></i>
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <td>#3</td>
          <td>
            IPD Module
          </td>
          <td>
          <span style={{padding:"5px 8px",borderRadius:"50%",backgroundColor:"rgba(193, 205, 222, 0.7)"}}>
            <i className="ri-empathize-line" />
            </span></td>
          <td>
            <div className="d-inline-flex gap-1">
              <button type="button" className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow">
                <i className="ri-delete-bin-line"/>
              </button>
              <button class="btn btn-outline-success btn-sm"
                  data-bs-toggle="modal" data-bs-target="#editModules"
                  data-bs-title="Edit Modules" type="button" onClick={()=>{setIds(3)}}>
                  <i class="ri-edit-box-line"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody> */}
                                <tbody>
                                  {modules.map((mod, index) => (
                                    <tr key={mod.moduleId}>
                                      <td>#{index + 1}</td>
                                      <td>{mod.moduleName}</td>
                                      <td>
                                        <span
                                          style={{
                                            padding: "5px 8px",
                                            borderRadius: "50%",
                                            backgroundColor: "rgba(193, 205, 222, 0.7)",
                                          }}
                                        >
                                          <i className={mod.moduleIcon}></i>
                                        </span>
                                      </td>
                                      <td>{mod.moduleDesc}</td>
                                      <td>
                                        <div className="d-inline-flex gap-1">
                                          <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            data-bs-toggle="modal"
                                            data-bs-target="#delRow"
                                            onClick={() => setDelId(mod.moduleId)}
                                          >
                                            <i className="ri-delete-bin-line" />
                                          </button>
                                          <button
                                            className="btn btn-outline-success btn-sm"
                                            data-bs-toggle="modal"
                                            data-bs-target="#editModules"
                                            data-bs-title="Edit Modules"
                                            type="button"
                                            onClick={() => setIds(mod.moduleId)}
                                          >
                                            <i className="ri-edit-box-line"></i>
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                  {modules.length === 0 && (
                                    <tr>
                                      <td colSpan="4" className="text-center">
                                        No modules found.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>)}
                          {/* Table ends */}
                          {/* Modal Delete Row */}
                          <div className="modal fade" id="delRow" tabIndex={-1} aria-labelledby="delRowLabel" aria-hidden="true">
                            <div className="modal-dialog modal-sm">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="delRowLabel">
                                    Confirm
                                  </h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                  Are you sure you want to delete the module from list?
                                </div>
                                <div className="modal-footer">
                                  <div className="d-flex justify-content-end gap-2">
                                    <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
                                    <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close"
                                      onClick={() => handleDelete(delId)}>Yes</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Modal Icon Row */}
                          <IconPickerModal modalId="addIconPicker" onSelect={setAddIcon} />

                          {/* Modal Edit Row */}
                          <div className="modal fade" id="editModules" tabIndex={-1} aria-labelledby="editModulesLabel" aria-hidden="true">
                            <div className="modal-dialog modal-lg">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="iconRowLabel">
                                    Edit
                                  </h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                  <div className="row justify-content-left">
                                    <div className="col-sm-12 col-12">
                                      <div className="card border mb-3">
                                        <div className="card-body">
                                          <div className="row gx-4">
                                            <div className=" col-sm-5 col-12">
                                              <div className="mb-3">
                                                <label className="form-label" htmlFor="editMod">New Module <span className="text-danger">*</span></label>
                                                <div className="input-group">
                                                  <input type="text" id="editMod" className="form-control" value={editModuleName} onChange={(e) => setEditModuleName(e.target.value)} />
                                                  <button className="btn btn-outline-secondary" type="button">
                                                    <i className="ri-menu-line text-black" />
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                            <div className=" col-sm-5 col-12">
                                              <div className="mb-3">
                                                <label className="form-label" htmlFor="newIcon">New icon <span className="text-danger">*</span></label>
                                                <div className="input-group">
                                                  <input type="text" id="newIcon" className="form-control" value={"Choose Icon"} disabled />
                                                  <button className="btn btn-outline-secondary" onClick={() => setShowIconPicker(true)}>
                                                    <i className="ri-menu-line text-black" />
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                            <div className=" col-sm-2 col-12 justify-content-end">
                                              <div className="mb-3">
                                                <label className="form-label" htmlFor="selectedIcon">&nbsp; </label>
                                                <div className="input-group">

                                                  {editIcon && (<button className="btn btn-outline-secondary" id="selectedIcon">
                                                    <i className={editIcon}></i>
                                                  </button>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                            <div className=" col-sm-10 col-12">
                                              <div className="mb-3">
                                                <label className="form-label" htmlFor="editDesc">Module Description <span className="text-danger">*</span></label>
                                                <div className="input-group">
                                                  <textarea type="text" id="editDesc" className="form-control" row="2" value={editModuleDesc} onChange={(e) => setEditModuleDesc(e.target.value)} />
                                                  <button className="btn btn-outline-secondary" type="button">
                                                    <i className="ri-menu-line text-black" />
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                            {showIconPicker && (
                                              <div class="col-sm-12 col-12">
                                                <div class="card">
                                                  <div class="card-body">
                                                    <div class="icons-container">
                                                      {icons.map((iconClass) => (
                                                        <button
                                                          key={iconClass}
                                                          className="btn"

                                                          onClick={() => {
                                                            setEditIcon(`${iconClass}`);
                                                            setShowIconPicker(false);
                                                          }}
                                                        >
                                                          <div className="icons" style={{ height: "50px", width: "50px", padding: "2px", fontSize: "16px" }}>
                                                            <i className={iconClass}></i>
                                                          </div>
                                                        </button>
                                                      ))}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )}


                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <div className="d-flex justify-content-end gap-2">
                                    <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
                                    <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={handleEdit}>Edit</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Tab content ends */}
                </div>
                {/* Custom tabs ends */}
                {/* Buttons starts */}

                {/* Buttons ends */}
              </div>
            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
      {/* App body ends */}
    </div>
  );
}
export default CreateModules;




